import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=301c0cf0&scoped=true&"
import script from "./activity-detail.vue?vue&type=script&lang=ts&"
export * from "./activity-detail.vue?vue&type=script&lang=ts&"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=301c0cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301c0cf0",
  null
  
)

export default component.exports